var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetaLogoVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 157,
    viewBox: "0 0 174 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.859 58.2959H120.871V67.4131H144.859V58.2959Z",
    fill: "url(#paint0_radial_644_39643)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.859 45.458H120.871V54.5752H144.859V45.458Z",
    fill: "url(#paint1_radial_644_39643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8323 67.4161H52.8206V58.2988H28.8323V67.4161Z",
    fill: "url(#paint2_radial_644_39643)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8323 54.5782H52.8206V45.4609H28.8323V54.5782Z",
    fill: "url(#paint3_radial_644_39643)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.863 29.7908V82.9275L96.9321 103.676V55.4131H117.38V39.4209H56.3077V55.4131H76.848V103.73L40.8247 82.9275V29.7908L86.8423 3.2207L132.863 29.7908Z",
    fill: "url(#paint4_radial_644_39643)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9841 116.674V121.791H23.9836V146.377H18.3004V121.791H9.34583V116.674H32.9841Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8584 146.802C36.457 146.802 34.6958 146.211 33.5748 145.026C32.4537 143.842 31.8949 141.988 31.8949 139.46C31.8949 136.931 32.5668 135.039 33.9072 133.964C35.2475 132.892 37.564 132.355 40.8459 132.355C41.7619 132.355 42.692 132.401 43.6398 132.496C44.5876 132.592 45.4081 132.719 46.1048 132.875V130.884C46.1048 129.653 45.7264 128.751 44.9695 128.185C44.2127 127.616 43.0103 127.333 41.3693 127.333C39.884 127.333 38.5648 127.379 37.4155 127.474C36.2625 127.57 35.1662 127.729 34.1229 127.948V123.354C35.3218 123.071 36.6268 122.856 38.0308 122.714C39.4348 122.573 41.1005 122.502 43.028 122.502C45.9032 122.502 48.0499 123.156 49.4716 124.468C50.8933 125.78 51.6041 127.747 51.6041 130.367V146.381H46.5362L46.2993 144.298H46.2038C45.1923 145.055 44.0323 145.663 42.7203 146.123C41.4082 146.579 40.1209 146.809 38.8584 146.809V146.802ZM41.5108 136.284C39.8062 136.284 38.6356 136.482 38.0061 136.874C37.373 137.271 37.0583 138.02 37.0583 139.124C37.0583 140.227 37.32 140.963 37.8398 141.423C38.3597 141.882 39.2545 142.109 40.517 142.109C41.433 142.109 42.402 141.974 43.4311 141.705C44.4567 141.437 45.3515 141.097 46.1083 140.687V136.659C45.3515 136.531 44.5982 136.439 43.859 136.376C43.1164 136.312 42.3348 136.28 41.5143 136.28L41.5108 136.284Z",
    fill: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1799 134.201L75.6632 146.378H69.598L64.7671 137.992L59.9821 146.378H54.2494L61.7822 134.201L54.4863 122.973H60.9299L65.195 130.601L69.697 122.973H75.4298L68.1834 134.201H68.1799Z",
    fill: "#1D1D1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5415 141.448C91.8359 141.448 93.2187 141.306 94.6863 141.02C96.154 140.737 97.4731 140.355 98.6402 139.884V144.952C96.9038 145.649 95.3477 146.13 93.9755 146.399C92.6033 146.668 91.171 146.802 89.6892 146.802C84.982 146.802 81.7001 145.624 79.8364 143.272C77.9726 140.921 77.0425 136.981 77.0425 131.453C77.0425 125.926 78.1459 122.318 80.3598 119.871C82.5701 117.424 86.1243 116.2 91.0189 116.2C92.4725 116.2 93.7668 116.232 94.9021 116.296C96.0373 116.359 97.0664 116.469 97.9824 116.628V121.601C96.7835 121.505 95.62 121.434 94.4989 121.388C93.3778 121.342 92.2178 121.318 91.0154 121.318C87.8254 121.318 85.6681 122.06 84.5506 123.546C83.4295 125.031 82.8672 127.666 82.8672 131.457C82.8672 135.248 83.38 137.862 84.4056 139.297C85.4312 140.733 87.4753 141.455 90.5415 141.455V141.448Z",
    fill: "#1D1D1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.736 146.374H102.24V122.972H107.308L107.545 124.868H107.687C108.854 124.175 110.039 123.637 111.241 123.259C112.44 122.88 113.61 122.689 114.746 122.689H115.386C115.495 122.689 115.584 122.707 115.648 122.735V128.04C115.457 127.977 115.213 127.938 114.912 127.924C114.611 127.909 114.099 127.899 113.374 127.899C112.267 127.899 111.241 127.994 110.293 128.182C109.345 128.373 108.493 128.641 107.736 128.988V146.374Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.709 149.267C122.876 149.267 123.746 149.055 124.316 148.627C124.885 148.199 125.373 147.308 125.783 145.95L116.592 122.973H122.749L128.577 140.549L134.119 122.973H140.039L131.085 147.417C130.2 149.819 129.118 151.523 127.838 152.535C126.558 153.546 124.878 154.052 122.791 154.052C122.158 154.052 121.511 154.02 120.85 153.956C120.185 153.893 119.601 153.815 119.096 153.719V149.125C119.347 149.189 119.647 149.228 119.997 149.242C120.344 149.256 120.913 149.267 121.702 149.267H121.709Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.382 153.574H142.886V122.972H147.671L148.003 125.105H148.24C149.124 124.253 150.182 123.605 151.413 123.163C152.643 122.721 154.033 122.498 155.582 122.498C158.74 122.498 160.99 123.439 162.333 125.317C163.674 127.195 164.346 130.3 164.346 134.625C164.346 138.95 163.508 142.024 161.835 143.933C160.162 145.843 157.414 146.798 153.591 146.798C152.516 146.798 151.536 146.727 150.652 146.586C149.768 146.444 149.011 146.246 148.378 145.995V153.574H148.382ZM158.85 134.625C158.85 131.877 158.496 129.992 157.785 128.963C157.075 127.937 155.692 127.425 153.641 127.425C152.661 127.425 151.731 127.534 150.847 127.757C149.963 127.98 149.142 128.295 148.382 128.705V140.927C148.951 141.182 149.605 141.369 150.348 141.496C151.091 141.624 151.936 141.687 152.884 141.687C155.317 141.687 156.919 141.207 157.694 140.245C158.468 139.283 158.854 137.412 158.854 134.632L158.85 134.625Z",
    fill: "#1D1D1B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.933,
    y: 103.306,
    width: 25.545,
    height: 10.6798,
    rx: 2.5,
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.615 111.236V105.418H141.745C142.158 105.418 142.5 105.486 142.771 105.623C143.042 105.757 143.244 105.94 143.379 106.171C143.513 106.4 143.581 106.659 143.581 106.947C143.581 107.189 143.536 107.394 143.447 107.56C143.358 107.725 143.239 107.858 143.089 107.958C142.941 108.056 142.778 108.128 142.6 108.174V108.231C142.794 108.24 142.982 108.303 143.166 108.418C143.351 108.532 143.505 108.694 143.626 108.904C143.747 109.114 143.808 109.37 143.808 109.671C143.808 109.968 143.738 110.235 143.598 110.472C143.459 110.707 143.245 110.894 142.956 111.032C142.666 111.168 142.295 111.236 141.845 111.236H139.615ZM140.492 110.483H141.76C142.18 110.483 142.481 110.402 142.663 110.239C142.845 110.076 142.936 109.873 142.936 109.628C142.936 109.445 142.889 109.276 142.796 109.123C142.704 108.969 142.571 108.847 142.399 108.756C142.228 108.665 142.026 108.62 141.791 108.62H140.492V110.483ZM140.492 107.935H141.669C141.866 107.935 142.043 107.897 142.2 107.822C142.359 107.746 142.485 107.64 142.578 107.503C142.672 107.365 142.72 107.202 142.72 107.015C142.72 106.774 142.635 106.573 142.467 106.41C142.298 106.247 142.04 106.165 141.691 106.165H140.492V107.935ZM146.661 111.324C146.232 111.324 145.861 111.233 145.551 111.049C145.242 110.863 145.003 110.603 144.835 110.268C144.668 109.93 144.585 109.536 144.585 109.083C144.585 108.636 144.668 108.242 144.835 107.901C145.003 107.56 145.238 107.294 145.539 107.103C145.842 106.912 146.197 106.816 146.602 106.816C146.848 106.816 147.087 106.857 147.318 106.938C147.549 107.019 147.756 107.147 147.94 107.322C148.124 107.496 148.269 107.722 148.375 108.001C148.481 108.277 148.534 108.613 148.534 109.009V109.31H145.065V108.674H147.701C147.701 108.45 147.656 108.252 147.565 108.08C147.474 107.906 147.346 107.769 147.181 107.668C147.019 107.568 146.827 107.518 146.608 107.518C146.369 107.518 146.161 107.576 145.983 107.694C145.806 107.809 145.67 107.961 145.573 108.148C145.479 108.334 145.431 108.536 145.431 108.753V109.251C145.431 109.542 145.483 109.79 145.585 109.995C145.689 110.199 145.834 110.356 146.019 110.464C146.205 110.57 146.422 110.623 146.67 110.623C146.831 110.623 146.978 110.6 147.11 110.555C147.243 110.507 147.358 110.437 147.454 110.344C147.551 110.251 147.625 110.137 147.676 110.001L148.48 110.145C148.415 110.382 148.3 110.59 148.133 110.768C147.968 110.944 147.761 111.081 147.511 111.18C147.263 111.276 146.98 111.324 146.661 111.324ZM151.513 106.873V107.555H149.13V106.873H151.513ZM149.769 105.827H150.618V109.955C150.618 110.12 150.643 110.244 150.692 110.327C150.741 110.409 150.805 110.465 150.882 110.495C150.962 110.523 151.048 110.537 151.141 110.537C151.209 110.537 151.269 110.533 151.32 110.523C151.371 110.514 151.411 110.506 151.439 110.501L151.593 111.202C151.543 111.221 151.473 111.24 151.382 111.259C151.291 111.28 151.178 111.291 151.041 111.293C150.818 111.297 150.61 111.257 150.416 111.174C150.223 111.09 150.067 110.962 149.948 110.787C149.828 110.613 149.769 110.394 149.769 110.131V105.827ZM153.723 111.333C153.446 111.333 153.196 111.282 152.973 111.18C152.749 111.075 152.572 110.925 152.441 110.728C152.313 110.531 152.248 110.289 152.248 110.003C152.248 109.757 152.295 109.555 152.39 109.395C152.485 109.236 152.613 109.11 152.774 109.018C152.935 108.925 153.115 108.855 153.313 108.807C153.512 108.76 153.715 108.724 153.921 108.699C154.183 108.669 154.395 108.644 154.558 108.626C154.721 108.605 154.839 108.572 154.913 108.526C154.987 108.481 155.024 108.407 155.024 108.305V108.285C155.024 108.037 154.954 107.844 154.813 107.708C154.675 107.572 154.469 107.503 154.194 107.503C153.908 107.503 153.683 107.567 153.518 107.694C153.355 107.819 153.242 107.958 153.18 108.111L152.382 107.93C152.476 107.664 152.615 107.45 152.796 107.287C152.98 107.123 153.191 107.003 153.43 106.93C153.669 106.854 153.92 106.816 154.183 106.816C154.357 106.816 154.542 106.837 154.737 106.878C154.934 106.918 155.117 106.992 155.288 107.1C155.46 107.208 155.601 107.362 155.711 107.563C155.821 107.762 155.876 108.02 155.876 108.339V111.236H155.046V110.64H155.012C154.957 110.75 154.875 110.858 154.765 110.964C154.655 111.07 154.514 111.158 154.342 111.228C154.17 111.298 153.963 111.333 153.723 111.333ZM153.907 110.651C154.142 110.651 154.343 110.605 154.51 110.512C154.678 110.419 154.806 110.298 154.893 110.148C154.982 109.997 155.027 109.835 155.027 109.662V109.1C154.996 109.13 154.938 109.159 154.85 109.185C154.765 109.21 154.668 109.232 154.558 109.251C154.448 109.268 154.341 109.284 154.237 109.299C154.133 109.312 154.045 109.323 153.975 109.333C153.811 109.354 153.66 109.389 153.524 109.438C153.389 109.487 153.281 109.558 153.2 109.651C153.12 109.742 153.081 109.863 153.081 110.015C153.081 110.225 153.158 110.384 153.313 110.492C153.469 110.598 153.667 110.651 153.907 110.651Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_644_39643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.233 55.2474) scale(30.3118 30.3118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#003169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_644_39643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.52271 55.2472) scale(30.3118 30.3118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#003169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_644_39643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.9879 56.5164) scale(63.1699 63.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#003169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_644_39643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.9879 56.5162) scale(63.1699 63.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#003169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_644_39643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.8459 53.4751) scale(48.182 48.182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0069AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0069AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#004282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#00336C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaLogoVertical);
export default __webpack_public_path__ + "static/media/betaLogoVertical.c7bcaba305d5af16daa90d29bd2bcbb5.svg";
export { ForwardRef as ReactComponent };